
// 3rd Party Components
import React, { Component } from 'react';

// Views
import EventView from './ministry/events/EventView';
import AnnouncementView from './ministry/announcements/AnnouncementView';
import SermonView from './sermons/SermonView';
import ApprovalView from './approvals/ApprovalView';
import Settings from './ministry/Settings';
import EventsWeekView from './overview/EventsWeekView';
import CalendarView from './overview/CalendarView';
import EncouragementView from './encouragement/EncouragementView';
import WeeklyPager from './ministry/weekly/WeeklyPager';
import Help from './ministry/Help';
import ApproveUserView from './approvals/ApproveUserView';
import Profile from './Profile';
import Permissions from './Permissions';
import ManageMinistry from './ministry/ManageMinistry';
import BugView from './bugs/BugView';
import MinistryDirectory from './ministry/MinistryDirectory';
import Resources from './Resources';
import PaymentsView from './financial/PaymentsView';
import Combined from './ministry/Combined';

// Custum Components
import { getTab, getPage, locationValid } from './util/Utility';
import { InfoView } from './util/Components';

//Thanks Geoffrey Crofte
function getArg(param) {
  var vars = {};
  window.location.href.replace(location.hash, '').replace(
    /[?&]+([^=&]+)=?([^&]*)?/gi, // regexp
    function(m, key, value) { // callback
      vars[key] = value !== undefined ? value : '';
    }
  );

  if (param) {
    return vars[param] ? vars[param] : null;
  }
  return vars;
}

export default class ContentView extends Component {

  render() {

    const location = this.props.location;

    const welcomeView = (
      <center>
        <div style={{marginTop: 50, maxWidth: 600, padding: 20}}>
          <p style={{color: 'gray', fontSize: '16pt', textAlign: 'center'}}>Welcome to the CCO App Management Platform</p>
          <p style={{color: 'gray', textAlign: 'center'}}>Choose a page from the dropdown</p>
          <div style={{backgroundColor: 'darkgray', maxWidth: 500, height: 1, marginTop: 30, marginBottom: 30}} />
          {this.props.permissions && this.props.permissions.ministries !== undefined && <div>
            <p style={{color: 'gray', fontSize: '16pt', textAlign: 'center'}}>Quick Start Guide for Ministry Leaders</p>
            <span style={{color: 'gray', textAlign: 'left'}}>
              <ul>
                <li>If you have not done so, make sure to update your bio under the Profile & Account page.</li>
                <li>Update the ministry description with any persistent information you want to share with people who are considering being a part of the ministry</li>
                <li>If you are the leader of a Bible Study or Outreach ministry and your recurring event is taking place at a different location or has a guest speaker for just one meeting, you can let your followers know by specifying in the appropriate tab on your ministries page.</li>
                <li>Post Announcements and Events as needed to keep members engaged in the ministry and inform them of what is happening.</li>
              </ul>
            </span>
          </div>}
          {this.props.permissions && Object.keys(this.props.permissions).length < 2 && <div>
            <p style={{color: 'gray', fontSize: '14pt', textAlign: 'center'}}>Waiting on Permissions</p>
            <p style={{color: 'gray'}}>It looks like you just created your account. Glad you made it in! If you are a ministry leader, you will not be able to access your ministry page until you are given the appropriate permissions by the system administrator.  However, you can still update your bio now by going to the Profile & Account page, and you should be given access your ministry page within the hour.</p>
          </div>}
        </div>
      </center>
    );

    const notFound = <InfoView title="Page Not Found" text="Please enter a valid URL or select an option from the dropdown" />

    var contentView = null;

    var ministry = this.props.ministry;

    if (location === "/" || location === "" || location === null) contentView = welcomeView;
    else if (this.props.pages) {

      if (this.props.pages.filter(item => item.to === "/" + getPage(location) || item.to === "/" + getPage(location) + "/announcements").length === 0) {
        if (location === "/profile") contentView = welcomeView;
        else if (!locationValid(location)) contentView = <InfoView title="Not Allowed" text="You don't have access to this page, sorry!" />;
        else contentView = notFound;
      }
      else
        switch (location) {
          case "/action":
            if (getArg['mode'] === "verifyEmail")
              contentView = (
                <center>
                  <div style={{marginTop: 50, maxWidth: 600, padding: 20}}>
                    <p style={{color: 'gray', fontSize: '18pt', textAlign: 'center'}}>Email Verification Complete!</p>
                    <p style={{color: 'gray', fontSize: '16pt', textAlign: 'center'}}>Welcome to the CCO App Management Platform</p>
                    <p style={{color: 'gray'}}>It looks like you just created your account. Glad you made it in! If you are a ministry leader, you will not be able to access your ministry page until you are given the appropriate permissions by the system administrator.  However, you can still update your bio now by going to the Profile & Account page, and you should be given access your ministry page within the hour.</p>
                  </div>
                </center>
              );
            break;
          case "/sermons": contentView = <SermonView {...this.props} />; break;
          case "/user_approval": contentView = <ApproveUserView {...this.props} />; break;
          case "/approval4": contentView = <ApprovalView type="approval4" {...this.props} />; break;
          case "/approval3": contentView = <ApprovalView type="approval3" {...this.props} />; break;
          case "/approval2": contentView = <ApprovalView type="approval2" {...this.props} />; break;
          case "/approval1": contentView = <ApprovalView type="approval1" {...this.props} />; break;
          case "/encouragement": contentView = <EncouragementView {...this.props} />; break;
          case "/account": contentView = <Profile {...this.props} />; break;
          case "/week": contentView = <EventsWeekView {...this.props} />; break;
          case "/calendar": contentView = <CalendarView {...this.props} />; break;
          case "/permissions": contentView = <Permissions {...this.props} />; break;
          case "/ministries": contentView = <ManageMinistry {...this.props} />; break;
          case "/bugs": contentView = <BugView {...this.props} />; break;
          case "/resources": contentView = <Resources />; break;
          case "/payments": contentView = <PaymentsView {...this.props} />; break;
          default:
            if (ministry) {
              contentView = <Combined updateMinistry={this.props.updateMinistry} ministry={ministry} {...this.props} />; break;
              //switch(getTab(location)) {
              //  case "settings": contentView = <Settings updateMinistry={this.props.updateMinistry} ministry={ministry} {...this.props} />; break;
              //  case "announcements": contentView = <AnnouncementView ministry={ministry} {...this.props} />; break;
              //  case "events": contentView = <EventView ministry={ministry} {...this.props} />; break;
              //  case "recurring": contentView = <WeeklyPager ministry={ministry} {...this.props} />; break;
              //  case "service": contentView = <Help ministry={ministry} {...this.props} />; break;
              //  case "n/a": contentView = <MinistryDirectory ministry={ministry} {...this.props} />; break;
              //  case "": contentView = <MinistryDirectory ministry={ministry} {...this.props} />; break;
              //  default: contentView = notFound; break;
              //}
            } else contentView = notFound;
            break;
        }
    }

    const divStyle = {
      width: '100%',
      height: '100%',
      marginTop: 120
    };

    return (
      <div style={divStyle}>
        {contentView}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/ContentView.js
 **/